import { IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

interface ConfirmationItemDescriptionProps {
  icon: IconDefinition;
  label: string;
  value: string;
  isDefaultWidth?: boolean;
}

export const ConfirmationItemDescription: React.FC<ConfirmationItemDescriptionProps> = ({
  icon,
  label,
  value,
  isDefaultWidth = true,
}) => {
  return (
    <div className={isDefaultWidth ? 'w-1/4' : 'w-1/3'}>
      <div className="mb-2 flex">
        <FontAwesomeIcon className="mt-1 w-1/4" icon={icon} />
        <p className="text-content-default-content-text w-3/4 text-sm font-medium leading-5">{label}</p>
      </div>
      <div className={'flex'}>
        <div className={'mt-1 w-1/4'}></div>
        <p className="text-content-default-content-text w-3/4 text-sm font-normal leading-5">{value}</p>
      </div>
    </div>
  );
};
